<template>
  <div class="w-fit">
    <MenuTriggerWrap
      menuName="ColorPickerMenu"
      width="dynamic"
      placement="right-of-trigger"
      :menuProps="menuProps">
      <button
        type="button"
        :aria-label="ariaLabel || undefined"
        :style="selectedColor ? { backgroundColor: selectedColor.color } : {}"
        :class="[
          'h-7 w-7 cursor-pointer rounded-full transition-shadow',
          !selectedColor ? 'flex items-center justify-center border-2 border-border-subtle bg-surface' : '',
        ]">
        <IconLucideBan
          v-if="!selectedColor"
          class="h-4 w-4 text-text-muted" />
      </button>
    </MenuTriggerWrap>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TResultColorId, IResultColor } from '@team-milva/lab-models/resources'
import { RESULT_COLORS } from '@team-milva/lab-models/resources'

export default {
  name: 'ColorPickerButton',

  emits: ['update:modelValue'],

  props: {
    modelValue: {
      type: String as PropType<TResultColorId | null>,
      default: null,
    },
    // The button holds only a colour swatch or an icon, so the caller says what it changes.
    ariaLabel: {
      type: String,
      default: '',
    },
  },

  computed: {
    selectedColor(): IResultColor | null {
      if (!this.modelValue) return null
      return Object.values(RESULT_COLORS).find((x) => x.id === this.modelValue) ?? null
    },

    menuProps(): Record<string, unknown> {
      return {
        value: this.modelValue,
        onSelect: (colorId: TResultColorId | null) => {
          this.$emit('update:modelValue', colorId)
        },
      }
    },
  },
}
</script>
